export class ChPerformanceCompanyChart {
    constructor(data) {
        this.companyId = data?.companyId ?? null;
        const report = data?.report ?? {};
        this.distinct = report?.distinct ?? [];
        this.cumulative = report?.cumulative ?? [];
    }

    getCompanyId() { return this.companyId; }
    getDistinct() { return this.distinct; }
    getCumulative() { return this.cumulative; }
}

export class ChPerformanceChartResponse {
    constructor(data) {
        this.companies = (data ?? []).map(c => new ChPerformanceCompanyChart(c));
    }

    getCompanies() { return this.companies; }
}

export class ChPerformanceCompanySummary {
    constructor(data) {
        this.companyId = data?.companyId ?? null;
        this.completedDeliveries = data?.completedDeliveries ?? 0;
        this.onTimeDeliveries = data?.onTimeDeliveries ?? 0;
        this.avgPromiseTime = data?.avgPromiseTime ?? 0;
        this.avgPlacementToPickupTime = data?.avgPlacementToPickupTime ?? 0;
        this.avgPickupToDeliveryTime = data?.avgDriveTime ?? data?.avgPickupToDeliveryTime ?? 0;
        this.avgPlacementToDeliveryTime = data?.avgPlacementToDeliveryTime ?? 0;
        this.pickupBefore20Min = data?.pickupBefore20Min ?? 0;
        this.deliveryBefore40Min = data?.deliveryBefore40Min ?? 0;
    }

    getCompanyId() { return this.companyId; }
}

export class ChPerformanceDrilldownOrder {
    constructor(data) {
        this.orderId = data?.orderId ?? null;
        this.companyId = data?.companyId ?? null;
        this.orderNumber = data?.orderNumber ?? '';
        this.customerName = data?.customerName ?? '';
        this.customerAddress = data?.customerAddress ?? '';
        this.placementTime = data?.placementTime ?? null;
        this.pickupTime = data?.pickupTime ?? null;
        this.deliveryTime = data?.deliveryTime ?? null;
        this.promisedDeliveryTime = data?.promisedDeliveryTime ?? null;
        this.driverName = data?.driverName ?? '';
        this.totalCost = data?.totalCost ?? 0;
    }
}

export class ChPerformanceDrilldownResponse {
    constructor(data) {
        this.page = data?.pageNumber ?? 1;
        this.pageSize = data?.pageSize ?? 25;
        this.totalCount = data?.totalCount ?? 0;
        this.totalPages = data?.totalPages ?? 0;
        this.truncated = data?.truncated ?? false;
        this.orders = (data?.data ?? []).map(o => new ChPerformanceDrilldownOrder(o));
        this.companiesWithOrders = new Set(this.orders.map(o => o.companyId).filter(Boolean)).size;
    }
}

export class ChPerformanceSummaryResponse {
    constructor(data) {
        this.companies = (data ?? []).map(c => new ChPerformanceCompanySummary(c));
    }

    getCompanies() { return this.companies; }
}
